///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { includes } from "lodash";

import messages from "../../../helpers/messages";
import CloseIcon from "../../icons/CloseIcon";
import { setRowsSelected } from "../../../slices/bidProcurementSlice";

export const LaneInformation = () => {
  const dispatch = useDispatch();
  const {
    bidProcurement: {
      capacityMatchLaneSummary: { capacityMatches },
      capacityMatchCarriers: { originalCarriers },
      rowsSelected
    },
    featureFlags: { showSlicCodes }
  } = useSelector(state => state);

  const HeaderCell = ({ columnName }) => {
    return <th>{columnName}</th>;
  };

  const BodyCell = ({ value, children, maxWidth }) => (
    <td className="body-cell" style={{ maxWidth: maxWidth }}>
      {value || children}
    </td>
  );

  const laneInfo = capacityMatches?.filter(x =>
    includes(rowsSelected, x.truckloadLaneId)
  );

  return (
    <div className="mt-12 pl-8">
      <table className="lane-info">
        <thead>
          <tr>
            <HeaderCell columnName={messages.laneId.defaultMessage} />
            <HeaderCell columnName={messages.origin.defaultMessage} />
            <HeaderCell columnName={messages.destination.defaultMessage} />
            <HeaderCell columnName={messages.volume.defaultMessage} />
            <HeaderCell
              columnName={
                showSlicCodes
                  ? messages.matchInfo.defaultMessage
                  : messages.incumbent.defaultMessage
              }
            />
            <HeaderCell />
          </tr>
        </thead>
        <tbody>
          {laneInfo?.map((x, index) => {
            const UPSCarriers = originalCarriers?.filter(
              c => c.laneId === x.truckloadLaneId && c.slicLanes?.length > 0
            );

            return (
              <tr key={index}>
                <BodyCell value={x.shipperLaneId} maxWidth={125} />
                <BodyCell
                  value={`${x.originCity}, ${x.originState} ${
                    x.originPostalCode ? x.originPostalCode : ""
                  }`}
                  maxWidth={135}
                />
                <BodyCell
                  value={`${x.destinationCity}, ${x.destinationState} ${
                    x.destinationPostalCode ? x.destinationPostalCode : ""
                  }`}
                  maxWidth={135}
                />
                <BodyCell value={x.volume} maxWidth={70} />
                <BodyCell maxWidth={105}>
                  {showSlicCodes ? (
                    <>
                      {x.incumbentMatchesCount ? (
                        <span
                          className={`carriers-cell mb-8`}
                          style={{ width: 90 }}
                        >
                          <FormattedMessage
                            {...messages.incumbentCount}
                            values={{
                              noOfIncumbentCarriers: x.incumbentMatchesCount
                            }}
                          />
                        </span>
                      ) : null}
                      {UPSCarriers && UPSCarriers.length > 0 ? (
                        <span className={`carriers-cell ups-tag`}>
                          <FormattedMessage
                            {...messages.upsCarriersCount}
                            values={{
                              noOfUPSCarriers: UPSCarriers.length
                            }}
                          />
                        </span>
                      ) : null}
                    </>
                  ) : (
                    <span
                      className={`carriers-cell ${
                        x.incumbentMatchesCount === 0 ? "no-carriers-cell" : ""
                      }`}
                    >
                      {x.incumbentMatchesCount ? (
                        <FormattedMessage
                          {...messages.carrierCount}
                          values={{
                            noOfCarriers: x.incumbentMatchesCount
                          }}
                        />
                      ) : (
                        messages.none.defaultMessage
                      )}
                    </span>
                  )}
                </BodyCell>
                {laneInfo.length > 1 ? (
                  <BodyCell>
                    <CloseIcon
                      height={12}
                      width={12}
                      className="cursor-pointer"
                      onClick={() =>
                        dispatch(setRowsSelected(x.truckloadLaneId))
                      }
                    />
                  </BodyCell>
                ) : (
                  <BodyCell></BodyCell>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LaneInformation;
